import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mod_wrap" }
const _hoisted_3 = { class: "mod_c" }
const _hoisted_4 = { class: "mod_c_title" }
const _hoisted_5 = { class: "mod_c_tbody" }

import { useRoute } from 'vue-router';
import Crumb from '@/components/Crumb.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_unref(route).meta.title == '下载中心' || _unref(route).name == 'LiveDownCenter ')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(Crumb),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(route).meta?.title), 1),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_router_view)
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
}
}

})